<div class="pmo-manager">
  <div class="pmo-toolbar">
    <button tds-button variant="primary" (click)="openCreate()">Add PMO</button>
  </div>

  @if (pmoViewModel().isFetching) {
    <div class="pmo-loading">
      <tds-icon name="progress_activity" class="spinner" data-testid="spinner" />
      <span>Loading...</span>
    </div>
  } @else {
    <table class="pmo-table">
      <thead>
        <tr>
          <th>File name</th>
          <th>Zones</th>
          <th>Sources</th>
          <th>Releases</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (pmo of pmoViewModel().pmos; track pmo.id) {
          <tr>
            <td>{{ pmo.originalFileName }}</td>
            <td>{{ zoneLabels(pmo) }}</td>
            <td>{{ sourceLabels(pmo) }}</td>
            <td>{{ releaseLabels(pmo) }}</td>
            <td class="pmo-row-actions">
              <button tds-button variant="secondary" (click)="openEdit(pmo)">Edit</button>
              <button tds-button variant="secondary-danger" (click)="remove(pmo)">Delete</button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5">No PMO configured.</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>


